import { Pipe, PipeTransform } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { UrlSecurityService } from '@platform-frontend/util';

@Pipe({
  name: 'safeUrl'
})
export class SafeUrlPipe implements PipeTransform {
  constructor(private urlSecurityService: UrlSecurityService) {}

  transform(url: string, urlType: 'iframe' | 'image'): SafeResourceUrl {
    if (urlType === 'iframe') {
      return this.urlSecurityService.bypassScriptOrIframeUrl(url);
    } else {
      return this.urlSecurityService.bypassLinkOrImageUrl(url);
    }
  }
}
